<template>
  <div class="height-full">
    <a-row class="m-b-10" :gutter="10">
      <a-col :xs="4" :sm="4" :md="4" :lg="3" :xl="2" :xxl="2">
        <LevleSelect v-model="level" />
      </a-col>
      <a-col :xs="4" :sm="4" :md="4" :lg="3" :xl="2" :xxl="2">
        <a-select
          class="width-full"
          placeholder="粮库"
          v-model="depot"
          allowClear
        >
          <a-select-option
            :value="key"
            v-for="(value, key) in depots"
            :key="key"
          >
            {{ value }}
          </a-select-option>
        </a-select>
      </a-col>
      <a-col :xs="4" :sm="4" :md="4" :lg="3" :xl="2" :xxl="2">
        <a-select
          class="width-full"
          placeholder="粮仓"
          v-model="store"
          allowClear
        >
          <a-select-option
            :value="key"
            v-for="(value, key) in stores"
            :key="key"
          >
            {{ value }}
          </a-select-option>
        </a-select>
      </a-col>
      <a-col :xs="4" :sm="4" :md="4" :lg="3" :xl="2" :xxl="2">
        <a-select
          class="width-full"
          placeholder="状态"
          v-model="status"
          allowClear
        >
          <a-select-option value="normal">
            正常
          </a-select-option>
          <a-select-option value="abnormal">
            异常
          </a-select-option>
        </a-select>
      </a-col>
      <a-col :xs="8" :sm="7" :md="6" :lg="5" :xl="5" :xxl="5">
        <a-input
          addon-before="摄像头型号"
          v-model="name"
          placeholder="搜索内容"
        >
          <a-icon slot="suffix" type="search" />
        </a-input>
      </a-col>
    </a-row>
    <div class="height-full">
      <tk-flex class="height-full" center middle v-if="isEmpty">
        <a-empty />
      </tk-flex>
      <div class="width-full height-full" v-else>
        <div class="min-heiget-90">
          <a-row :gutter="[16, 16]" type="flex">
            <a-col
              v-for="item in datas"
              :key="item.objectId"
              :xs="24"
              :sm="24"
              :md="12"
              :lg="12"
              :xl="8"
              :xxl="8"
            >
              <EquipmentCard :equipment="item" />
            </a-col>
          </a-row>
        </div>
        <tk-flex class="m-t-20" right>
          <a-pagination
            show-quick-jumper
            v-model="current"
            :pageSize.sync="pageSize"
            :pageSizeOptions="['9', '12', '15', '18']"
            showSizeChanger
            :total="total"
            @change="onChange"
            @showSizeChange="onShowSizeChange"
          />
        </tk-flex>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
import EquipmentCard from '../../components/equipment/card'
import LevleSelect from '../../components/levleSelect'

export default {
  components: {
    EquipmentCard,
    LevleSelect
  },
  data () {
    return {
      // selects
      depots: {},
      stores: {},
      // list + page
      datas: [],
      total: 0,
      pageSize: 9,
      current: 1,
      // filter
      level: undefined,
      depot: undefined,
      store: undefined,
      status: undefined,
      name: undefined
    }
  },
  computed: {
    ...mapGetters(['userLevelTag']),
    isEmpty () {
      return this.datas && this.datas.length === 0
    },
    filterObj () {
      const json = {}
      if (this.name) {
        json['name'] = { $regex: this.name }
      }
      if (this.level) {
        // json['hierarchy'] = this.level
        json['hierarchy'] = {
          $inQuery: {
            where: {
              tag: { $regex: '^' + this.level }
            },
            className: 'hierarchy'
          }
        }
      } else {
        json['hierarchy'] = {
          $inQuery: {
            where: {
              tag: { $regex: '^' + this.userLevelTag }
            },
            className: 'hierarchy'
          }
        }
      }
      if (this.store) {
        json['grainstore'] = this.store
      }
      if (this.depot) {
        json['graindepot'] = this.depot
      }
      if (this.status) {
        json['status'] = this.status
      }
      return json
    }
  },
  watch: {
    filterObj () {
      this.current = 1
      this.init()
    },
    level (newV) {
      if (newV && newV.length > 0) {
        this.updateDepots(newV)
        this.updateStores()
      } else {
        this.updateDepots()
        this.updateStores()
      }
    },
    depot (newV) {
      if (newV) {
        this.updateStores(newV)
      } else {
        this.updateStores()
      }
    }
  },
  mounted () {
    this.init()
  },
  methods: {
    transformSelects (list) {
      const json = {}
      list.forEach(element => {
        json[element.objectId] = element.name
      })
      return json
    },
    async updateDepots (level) {
      this.depot = undefined
      if (level) {
        const res = await this.$tkParse.get('/classes/grainWarehouse', {
          params: {
            where: {
              hierarchy: {
                $inQuery: {
                  where: {
                    tag: { $regex: '^' + this.level }
                  },
                  className: 'hierarchy'
                }
              }
            },
            limit: Number.MAX_SAFE_INTEGER
          }
        })
        this.depots = this.transformSelects(res.data.results)
      } else {
        this.depots = {}
      }
    },
    async updateStores (depot) {
      this.store = undefined
      if (depot) {
        const res = await this.$tkParse.get('/classes/grainStorehouse', {
          params: {
            where: {
              grainWarehouse: depot
            },
            limit: Number.MAX_SAFE_INTEGER
          }
        })
        this.stores = this.transformSelects(res.data.results)
      } else {
        this.stores = {}
      }
    },
    async init () {
      this.$loading.show()
      this.datas = []
      const results = await Promise.all([
        this.queryListInfo(),
        this.queryInfoSum()
      ])
      this.datas = results[0]
      this.total = results[1]
      this.$loading.hide()
    },
    async reset () {
      this.$loading.show()
      this.datas = []
      const results = await Promise.all([this.queryListInfo()])
      this.datas = results[0]
      this.$loading.hide()
    },
    async queryListInfo () {
      const res = await this.$tkParse.get('/classes/equipment', {
        params: {
          include: 'grainstore,graindepot',
          order: '-createdAt',
          where: this.filterObj,
          limit: this.pageSize,
          skip: (this.current - 1) * this.pageSize
        }
      })
      return res.data.results
    },
    async queryInfoSum () {
      const res = await this.$tkParse.get('/classes/equipment', {
        params: {
          where: this.filterObj,
          limit: Number.MAX_SAFE_INTEGER,
          keys: 'objectId'
        }
      })
      return res.data.results.length
    },
    async onChange () {
      this.$loading.show()
      this.datas = await this.queryListInfo()
      this.$loading.hide()
    },
    onShowSizeChange () {
      this.current = 1
      this.init()
    }
  }
}
</script>
<style></style>
